import { isDeepEqual } from 'remeda';

import { type LeavePromptEntry } from '@@scripts/store/useLeavePromptStore';

type BlockerLocation = {
    routeId: string;
    pathname: string;
    search: Partial<Record<string, unknown>>;
};

/**
 * Whether navigating from `current` to `next` asks for the entry: the next location leaves the route
 * match that shows its changes, or changes a search param they depend on.
 */
export const shouldPrompt = (
    entry: LeavePromptEntry,
    current: BlockerLocation,
    next: BlockerLocation,
) => {
    if (entry.exact && next.pathname !== current.pathname) {
        return true;
    }

    // A route's id starts with the id of its parent
    const keepsRoute =
        next.routeId === entry.routeId || next.routeId.startsWith(`${entry.routeId}/`);
    // An index route's path ends with a slash
    const path = entry.pathname.replace(/\/$/, '');
    const keepsPath = next.pathname === path || next.pathname.startsWith(`${path}/`);
    const keepsSearch = entry.searchKeys.every((key) =>
        isDeepEqual(current.search[key], next.search[key]),
    );

    return !keepsRoute || !keepsPath || !keepsSearch;
};
